import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import { connect, useSelector, useDispatch } from "react-redux";
import { Memberships, membershipDelete } from "../../redux/action/Memberships";
import ViewMembership from "./ViewMembership";
import { ToastContainer } from "react-toastify";
import { APIURL } from "../../redux/action/config";
import search from "../../utils/search";
import Pagination from "./../../components/Pagination";
import { CSVLink } from "react-csv";
import TableStatusRow from "../../components/loader/TableStatusRow";
import { upadteMemberships } from "../../redux/action/Memberships";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
const MembershipList = ({ pageLoading, memberListData, not_found }) => {
  const [productDataList, setProductDataList] = useState([]);
  const onChangePage = (pageOfItems) => {
    setProductDataList(pageOfItems);
  };
  //
  const [viewDetails, setViewDetails] = useState();
  const [id, setId] = useState();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const loadList = async () => {
    setLoading(true);
    try {
      await dispatch(Memberships());
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadList();
  }, [dispatch]);

  const handleGetId = (e, id) => {
    e?.preventDefault();
    if (!id) return;
    if (id !== undefined) {
      setViewDetails("");
      const token = localStorage.getItem("token");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${APIURL}/api/v1/membership/${id}`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          setViewDetails(result?.data?.membership);
        })
        .catch((error) => console.log("error", error));
    }
  };

  const membership = memberListData?.data?.membership
    ? memberListData?.data?.membership
    : "";

  const MembershipDel = (id) => {
    dispatch(membershipDelete(id));
    setTimeout(() => {
      loadList();
    }, 1000);
  };

  const headers = [
    { label: "_id", key: "id" },
    { label: "Membership Name", key: "name" },
    { label: "Order Counts", key: "order" },
    { label: "Price($)", key: "price" },
    { label: "Image", key: "image" },
    { label: "Description", key: "description" },
    { label: "Created_At", key: "created" },
    { label: "Updated_At", key: "updated" },
  ];
  const data = productDataList
    ? productDataList?.map((item) => {
        return {
          id: item?._id ? item?._id : "N/A",
          name: item.name ? item.name : "N/A",
          order: item?.order_Counts ? item?.order_Counts : "N/A",
          price: item?.price ? item?.price : "N/A",
          image: item?.image ? item?.image : "N/A",
          description: item?.description ? item?.description : "N/A",
          created: item?.createdAt ? item?.createdAt : "N/A",
          updated: item?.updatedAt ? item?.updatedAt : "N/A",
        };
      })
    : "";

  const getBadge = (status) => {
    switch (status) {
      case "active":
        return "success";
      case "inactive":
        return "secondary";
      default:
        return "primary";
    }
  };

  const handleChangeStatus = (e, id) => {
    const status = e.target.checked;
    let statusType = "inactive";
    if (status === true) {
      statusType = "active";
    } else {
      statusType = "inactive";
    }
    const payload = {
      status: statusType,
    };
    dispatch(
      upadteMemberships(payload, id, (res) => {
        dispatch(Memberships());
      })
    );
  };

  // pdf code start
  const downloadPDF = () => {
    const capture = document.querySelector(".table");
    html2canvas(capture).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      console.log("Image Data:", imgData); // Debugging: Log the image data
      const doc = new jsPDF("p", "mm", "a4");
      const imgWidth = 200; // Adjust this based on your needs
      const imgHeight = (imgWidth * canvas.height) / canvas.width; // Maintain aspect ratio
      doc.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      doc.save("roadside-response.pdf");
    });
  };
  // pdf code end
  return (
    <React.Fragment>
      <ToastContainer autoClose={1000} />
      <Layout title="Manage Memberships" page="memberships">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            <div className="row pt-4 pb-4">
              <div className="col-sm-6 d-flex align-items-center justify-conten-start">
                <div
                  className="dataTables_length"
                  id="kt_datatable_example_5_length"
                >
                  {/* <label>
                    Show
                    <select
                      name="kt_datatable_example_5_length"
                      aria-controls="kt_datatable_example_5"
                      className="form-select form-select-sm form-select-solid"
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </label> */}
                </div>
              </div>
              <div className="col-sm-6 d-flex align-items-center justify-content-end">
                <div
                  id="kt_datatable_example_5_filter"
                  className="dataTables_filter"
                >
                  <label>
                    Search:
                    <input
                      type="search"
                      onChange={() => {
                        search();
                      }}
                      id="myInput"
                      className="form-control form-control-sm form-control-solid"
                      placeholder=""
                      aria-controls="kt_datatable_example_5"
                    />
                  </label>
                </div>
                <div className="ms-3">
                  <a
                    className="btn pgf btn-secondary dropdown-toggle"
                    href="#"
                    // role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    // className="csvlink"
                    style={{ background: "none" }}
                  >
                    Download File
                  </a>

                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item">
                        <CSVLink
                          style={{ color: "#000" }}
                          data={data}
                          headers={headers}
                        >
                          Download as CSV
                        </CSVLink>
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" onClick={downloadPDF}>
                        Download as PDF
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="table-responsive table-wrapper">
              <table
                id="kt_datatable_example_5"
                className="table table-striped table-row-bordered gy-5 gs-7 border rounded dataTable no-footer"
                aria-describedby="kt_datatable_example_5_info"
              >
                <thead>
                  <tr className="fw-bolder fs-6 text-gray-800 px-7 arrow-none">
                    <th>Membership Name</th>
                    <th>Order Counts</th>
                    <th>Yearly Price($)</th>
                    <th>Monthly Price($)</th>
                    <th>Daily Price($)</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading || (!productDataList?.length && membership?.length) ? (
                    <TableStatusRow loading colSpan={7} />
                  ) : membership?.length ? (
                    productDataList &&
                    productDataList?.map((item, index) => {
                      return (
                        <tr key={index} className="pro-list-info status">
                          <td>{item.name ? item.name : "N/A"}</td>
                          <td>
                            {item.order_Counts ? item.order_Counts : "N/A"}
                          </td>
                          <td>
                            {item.price ? `$${item.price}` : "Not Available"}
                          </td>
                          {console.log(item, "item==>")}
                          <td>
                            {item.priceMonthly
                              ? `$${item.priceMonthly}`
                              : "Not Available"}
                          </td>
                          <td>
                            {item.priceDaily
                              ? `$${item.priceDaily}`
                              : "Not Available"}
                          </td>
                          {/* <td>
                            {" "}
                            <span
                              className={`btn text-capitalize ${getBadge(
                                item.status
                              )}`}
                            >
                              {item.status ? item.status : "N/A"}
                            </span>
                          </td> */}
                          <td>
                            <div className="status-toggle">
                              <div className="form-check form-switch">
                                {/* <lable>{item.status}</lable> */}
                                <input
                                  title={`${item.status}`}
                                  className="form-check-input"
                                  onChange={(e) =>
                                    handleChangeStatus(e, item?.id)
                                  }
                                  checked={
                                    item.status === "active" ? true : false
                                  }
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckChecked"
                                />
                              </div>
                            </div>
                          </td>
                          <td className="d-flex align-items-center">
                            <a
                              type="button"
                              onClick={(e) => handleGetId(e, item?.id)}
                              className="btn btn-primary"
                              data-bs-toggle="modal"
                              data-bs-target="#membershipDetailModal"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-eye-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                              </svg>
                            </a>
                            <ViewMembership
                              modalId={"membershipDetailModal"}
                              viewDetails={viewDetails ? viewDetails : ""}
                            />
                            {/* <Link
                              to="#"
                              onClick={() => setId(item.id)}
                              className="btn btn-bg-primary action-hover"
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModal"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-eye-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                              </svg>
                            </Link> */}
                            <Link
                              to={`/edit-membership/${item.id}`}
                              onClick={() => setId(item.id)}
                              className="btn btn-info action-hover"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-pencil-square"
                                viewBox="0 0 16 16"
                              >
                                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"></path>
                                <path
                                  fillRule="evenodd"
                                  d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                ></path>
                              </svg>
                            </Link>
                            <Link
                              to="/manage-membership"
                              onClick={() => MembershipDel(item.id)}
                              className="btn btn-bg-dark action-hover"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-trash-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                              </svg>
                            </Link>
                            {/* <div className="status-toggle">
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  onChange={(e) =>
                                    handleChangeStatus(e, item?.id)
                                  }
                                  checked={
                                    item.status === "active" ? true : false
                                  }
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckChecked"
                                />
                              </div>
                            </div> */}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <TableStatusRow colSpan={7} message="Data not found" />
                  )}
                </tbody>
              </table>
            </div>
            <Pagination
              pageSize={10}
              items={membership}
              onChangePage={onChangePage}
            />
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  pageLoading: state?.Memberships?.loading,
  memberListData: state?.Memberships?.list,
  not_found: state?.Memberships?.not_found,
});

export default connect(mapStateToProps, { Memberships, membershipDelete })(
  MembershipList
);
